import {Rosters} from "./models.js";

function Brand() {

    // Strings
    const name = null;
    const weeklyShowName = null;
    const color = null;

    // Integer
    const overness = 45;

    // Boolean
    const weeklyShowIsExclusive = false;
    const hot = false;
    const stale = false;

    // Foreign keys
    const rosterId = null;

    return {
        name,
        weeklyShowName,
        color,
        overness,
        weeklyShowIsExclusive,
        hot,
        stale,
        rosterId
    };
}

function getBrandRoster(brand) {
    return Rosters.find({'$loki': brand.rosterId})[0];
}

export {Brand, getBrandRoster};